import * as React from "react";
import FormInput, { FormInputProps } from "./FormInput";

export const FormPassword: React.FC<Omit<FormInputProps, "type">> = props => (
  <FormInput {...props} type="password" />
);

export default FormPassword;
